import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { Button } from '@/Atomic/Molecules/Button'
import { ConfirmationModal } from '@/Components/shared/modals/ConfirmationModal'
import { useModalHandler } from '@/hooks/useModalHandler'

import './DeleteConnectionButton.scss'

export const DeleteConnectionButton = ({
  dataItem,
  title,
  subtitle,
  className,
}: {
  dataItem: DataItem
  title?: string
  subtitle?: string
  className?: string
}) => {
  const { t } = useTranslation()
  const { isOpen, closeModal, openModal } = useModalHandler()

  const modalTitle = title || t('connection.modal.delete.title')
  const modalSubtitle = subtitle || t('connection.modal.delete.subtitle')

  return (
    <>
      <Button
        variant="icon"
        icon="cross-circle"
        tooltip={t('tooltip.deleteConnection')}
        buttonClassName={className ?? 'delete-connection-button'}
        onClick={openModal}
      />
      <ConfirmationModal
        isOpen={isOpen}
        confirm={() => dataItem.delete()}
        close={closeModal}
        title={modalTitle}
        subtitle={modalSubtitle}
        variant="danger"
      />
    </>
  )
}
